<template>
  <div>
    <el-card>
      <el-table :data="listData" border>
        <el-table-column
          prop="medicalprescription"
          label="处方医技"
          :formatter="prescription"
        ></el-table-column>
        <el-table-column prop="projecttype" label="处方类型"></el-table-column>
        <el-table-column prop="docname" label="医生名称"></el-table-column>
        <el-table-column prop="costdate" label="费用日期"></el-table-column>
        <el-table-column label="药品信息" width="250">
          <template slot-scope="scope">
            <p v-for="(item, index) in scope.row.drugList" :key="index">
              {{ item.costname }} ￥{{ item.price }} X {{ item.itemnumber }}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="totalcost" label="合计金额"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: {},
      listData: [],
    };
  },
  mounted() {
    this.list = this.$store.state.prescription;
    this.init();
  },
  methods: {
    getDetails(row) {
      this.$router.push({
        path: "/main/PrescriptionDetailed",
        query: { id: row.identificationnumber },
      });
    },
    prescription(row) {
      return row.medicalprescription == "1" ? "处方" : "检查单";
    },
    async init() {
      let that = this;
      let options = {
        token: localStorage.getItem("token"),
        hosid: that.list.orgid,
        patientId: that.list.patientid,
        orderId: that.list.regid,
      };
      let res = await this.$http(
        "smarthos.yygh.select.prescribe.record.regid.list",
        options
      );
      if (res.code == 0) {
        that.listData = res.recordList;
      }
    },
  },
};
</script>
<style>
</style>